// extracted by mini-css-extract-plugin
export default {"basicHeader":"BasicHeader_basicHeader__QAxQ5","basicHeaderTitle":"BasicHeader_basicHeaderTitle__mMTva","basicHeaderStandfirst":"BasicHeader_basicHeaderStandfirst__QZ2Qb"};